"use client";

import Link from "next/link";
import { SidebarMenuItem } from "@/components/ui/sidebar";
import { DashboardSidebarGroupItem } from "./dashboard-sidebar-group-item";
import SidebarMenuButtonWithPath from "./sidebar-menu-button-with-path";

type Props = {
  dashboardName: string;
  linkHref: string;
  activePattern: string;
};

/**
 * DragOverlay専用のダッシュボードアイテムコンポーネント
 * 衝突判定と視覚的表現を適切に分離
 */
export default function DragOverlayDashboard({
  dashboardName,
  linkHref,
  activePattern,
}: Props) {
  return (
    <SidebarMenuItem>
      <SidebarMenuButtonWithPath activePattern={activePattern} asChild>
        <Link
          href={linkHref}
          style={{
            pointerEvents: "none", // ドラッグ中はクリック不可
          }}
        >
          <DashboardSidebarGroupItem name={dashboardName} isDragging={false} />
        </Link>
      </SidebarMenuButtonWithPath>
    </SidebarMenuItem>
  );
}
